<template>
  <main 
    :class="{ 'page-wrapper': true, 'overlay': menuOpen }"
  >
    <component 
      v-if="content"
      :is="content.component"
      :content="content" 
    >
    </component>
    <div v-else>
      Something to say we do not have any content..??
    </div>
  </main>
</template>

<script>

  // import our vuex state management
  import store from '@/store';

  // our various page types that will be utilised
  import FrontCover from '@/components/FrontCover.vue';
  import PageTypeA from '@/components/PageTypeA.vue';
  import BackCover from '@/components/BackCover.vue';
  
  export default {
    name: 'PageController',
    props: {
      menuOpen: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        allContent: store.getters.getAllPageContent,
        pageId: parseInt(this.$route.params.pageid) || null,
      }
    },  
    metaInfo: {
      changed() {
        if (window['__PRERENDER_INJECTED']) {
          document.dispatchEvent(new Event('render-event'))
        }
      }
    },
    computed: {

      content() {
        return store.getters.getActiveContent
      }

    }, 
    components: {
      FrontCover,
      PageTypeA,
      BackCover
    },    
    beforeMount() {
      store.dispatch('setActiveContent', { pageId : this.pageId });
    }

  };
</script>